import { render } from "./pdfOrder.vue?vue&type=template&id=a3b7e20c"
import script from "./pdfOrder.vue?vue&type=script&lang=js"
export * from "./pdfOrder.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ittiwutwongsawat/Documents/GitHub/clinic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__